export const MontageOnBaseDocumentationMarkdown = `
# Montage OnBase REST API

Makes a request to a Montage OnBase API instance, providing secure authentication and session management.
This block inherits many of the features of the [REST API Call block](https://docs.notablehealth.com/platform-components/block-library/rest-api) and the [FHIR v2 block](https://docs.notablehealth.com/platform-components/block-library/advanced-fhir)—review those docs for detailed usage of shared features like error handling, response parsing, and template syntax.

---

## When to use it

- Use this block when your flow needs to interact with a Montage OnBase system (e.g., document retrieval, workflow triggers, metadata lookups).
- Prefer this block over the generic REST block when targeting OnBase, since it handles authentication and session lifecycle automatically via the selected API Instance.

---

## Comparison: REST vs. FHIR v2 vs. Montage OnBase

| Feature             | REST Block                          | FHIR v2 Block                                      | Montage OnBase Block                                       |
|---------------------|-------------------------------------|-----------------------------------------------------|------------------------------------------------------------|
| **Endpoint scope**  | Any HTTP endpoint                   | Any FHIR path on your selected API Instance         | Any OnBase path on your selected API Instance              |
| **Authentication**  | Manual (per-block)                  | Automatic via API Instance (secure token rotation)  | Automatic via API Instance (secure token rotation)         |
| **Rate limiting**   | Not supported                       | Configurable per API Instance                       | Configurable per API Instance                              |
| **Request body**    | None / JSON / Form URL Encoded      | None / JSON / Form URL Encoded                      | None / JSON                                                |
| **Setup**           | No setup required                   | Requires a pre-configured API Instance              | Requires a pre-configured API Instance                     |

---

## Configuration Options

| Field              | Description                                                                                     |
|--------------------|-------------------------------------------------------------------------------------------------|
| **API Instance**   | Select one of your configured API Instances (manage them [here](https://app.notablehealth.com/staff/app#/api-instances)). Instances are scoped to the flow's organization. |
| **Method**         | HTTP verb: GET, POST, PUT, PATCH, or DELETE.                                                    |
| **Endpoint**       | Resource path appended to the API Instance's base URL (e.g. \`/api/documents\`).                |
| **Headers**        | Additional request headers. Authorization is injected automatically.                            |
| **Body**           | JSON request body (available for POST, PUT, and PATCH methods only).                            |

---

_For everything else (secure headers, error handling, metadata bindings, response parsing, etc.), see the [REST block documentation](https://docs.notablehealth.com/platform-components/block-library/rest-api)._
`;
